module.exports = __webpack_public_path__ + "static/media/08_servo-hub-module.bfc5bf25.mp4";